import { createTelemetryObject, createTelemetry } from '@shared/core/analytics';

const categoryByContext = { print: 'messaging.card', contactCollector: 'admin.contactcollector', guestList: 'admin.guestlist' };
const pageByContext = { print: 'customize', contactCollector: 'manage', guestList: 'root' };

const contactCollectorTelemetry = createTelemetryObject({
  actions: {
    trackError: (context: Context, action: 'Mutation' | 'Other', extraInfo) => ({
      category: categoryByContext[context],
      pagePrefix: 'admin',
      page: pageByContext[context],
      action,
      actionType: 'error',
      extraInfo,
    }),
    buttonInteracted: (context: Context, extraInfo) => ({
      category: categoryByContext[context],
      pagePrefix: 'admin',
      page: pageByContext[context],
      action: 'MessagingButtonInteracted',
      extraInfo,
    }),
    trackInvalidPostalCode: (context: Context, extraInfo) => ({
      category: categoryByContext[context],
      pagePrefix: 'admin',
      page: pageByContext[context],
      action: 'InvalidPostalCode',
      extraInfo,
    }),
  },
});

const { TelemetryProvider, useTelemetry } = createTelemetry(contactCollectorTelemetry);
const useCSVUploadTelemetry = useTelemetry;
export { TelemetryProvider, useCSVUploadTelemetry };
